// SYSTEM_ROUTE: /mental
import { JournalView } from './JournalView.js';

export function MentalScreen() {
  return (
    <JournalView
      stream="mental"
      title="Mental"
      subtitle="Journal, reflection, mental models, and deep-work notes. A private space to think clearly."
      placeholder="What's on your mind? A thought, a model, a reflection…"
      privacyNote="Strictly local — never synced or shared."
    />
  );
}
